import { RefObject, useCallback } from "react";
import { Editor as EditorRef } from "@tinymce/tinymce-react/lib/cjs/main/ts/components/Editor";
import { useAtom, useAtomValue } from "jotai";
import { activeSSMLTagsAtom } from "atoms";
import { SSMLTag } from "shared/constants";
import { removeSSMLTag } from "shared/utils/ssml-helper";

export const useIsActiveSSMLTag = (tag: SSMLTag): boolean => {
  const activeSSMLTags = useAtomValue(activeSSMLTagsAtom);
  return activeSSMLTags.some((activeTag) => activeTag.startsWith(`${tag}-`));
};

export const useSSMLTagRemover = (editorRef: RefObject<EditorRef | null>) => {
  const [activeSSMLTags, setActiveSSMLTags] = useAtom(activeSSMLTagsAtom);

  return useCallback(
    (tagType: SSMLTag) => {
      if (editorRef.current && editorRef.current.editor) {
        removeSSMLTag(editorRef.current.editor, tagType, activeSSMLTags);

        // Update the activeSSMLTagsAtom to remove the tag
        setActiveSSMLTags((prevTags) =>
          prevTags.filter((tag) => !tag.startsWith(`${tagType}-`))
        );
      }
    },
    [editorRef, activeSSMLTags, setActiveSSMLTags]
  );
};
